import reqwest from 'reqwest'

export default {
  install: (Vue, options) => {
    Vue.prototype.$ajax = function (methodOptions) {
      var promise = new Promise((resolve, reject) => {
        methodOptions.loadingName && (this.$data[methodOptions.loadingName] = true)
        reqwest({
          url: typeof methodOptions === 'string' ? methodOptions : methodOptions.url,
          type: methodOptions.type || 'json',
          method: methodOptions.method || ((methodOptions.data && typeof methodOptions.data === 'string') ? 'post' : 'get'),
          contentType: methodOptions.contentType == null ? 'application/json' : methodOptions.contentType,
          data: methodOptions.data || {},
          processData: methodOptions.processData == null ? true : methodOptions.processData,
          complete: methodOptions.complete || (() => { methodOptions.loadingName && (this.$data[methodOptions.loadingName] = false) }),
          error: methodOptions.error || ((err) => {
            this.$message({
              message: err.response || err.statusText,
              type: 'error'
            })
          }),
          success: (response) => {
            // NProgress.done();
            console.log(response)
            let { data, msg, status } = response
            if (msg != null && status !== 0) {
              reject(response)
              this.$message({
                message: msg,
                type: 'error'
              })
            } else {
              resolve(response)
              methodOptions.success && methodOptions.success(data, response)
            }
          }
        })
      })
      return promise
      // return r.then((res) => {
      //   var promise = new Promise((resolve, reject) => {
      //     let { status, msg } = res
      //     if (status !== 0) {
      //       throw new Error(msg)
      //     } else {
      //       resolve(res)
      //     }
      //   })
      //   return promise
      // })
    }
  }
}
